import React from 'react';
import { Radio } from '@mui/material';
import { fmtMoney, fmtPercent } from '@upstart/harmony/lib/formatter';
import classNames from 'classnames';
import { RehashOffer } from '../RehashPossibleModal';
import OfferOptionTileExtra from './OfferOptionTileExtra';
import './OfferOptionTile.scss';

export interface OfferOptionTileProps {
  iconElement: React.ReactNode;
  offer: RehashOffer;
  selected: boolean;
  onClick: () => void;
  title: string;
}

const OfferOptionTile: React.FC<OfferOptionTileProps> = ({
  iconElement,
  offer,
  selected,
  onClick,
  title,
}) => {
  const products = offer.accessoriesAndProducts.selectedProducts;
  const accessories = offer.accessoriesAndProducts.selectedAccessories;
  const addOns = offer.accessoriesAndProducts.selectedAddOns;

  return (
    <div className={classNames('offer-option', { selected })} onClick={onClick}>
      <div className="offer-option__info">
        <div className="offer-option__title">
          <Radio checked={selected} color="secondary" />
          {title}
        </div>
        <div className="offer-option__details">
          {fmtMoney(offer.monthlyPayment, 2)}/mo
          <div className="offer-option__divider" />
          {fmtPercent(offer.apr)}
          <div className="offer-option__divider" />
          {offer.contractMonths}/mo
          <div className="offer-option__divider" />
          {fmtMoney(offer.downPayment, 2)} down
        </div>
      </div>

      <OfferOptionTileExtra
        title="Protection Plans"
        items={(products || []).map(product => product.displayName || '')}
        iconElement={iconElement}
      />

      <OfferOptionTileExtra
        title="Add Ons"
        items={(addOns || []).map(addOn => addOn.description || '')}
        iconElement={iconElement}
      />

      <OfferOptionTileExtra
        title="Accessories"
        items={(accessories || []).map(accessory => accessory.name || '')}
        iconElement={iconElement}
      />
    </div>
  );
};

export default OfferOptionTile;
